import { render, staticRenderFns } from "./shoppingCartCounterComponent.vue?vue&type=template&id=226f5ddf"
import script from "./shoppingCartCounterComponent.vue?vue&type=script&lang=js"
export * from "./shoppingCartCounterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports